import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { defaultLocaleCtx, DEFAULT_NAMESPACE } from './constants.js';

var isServer = typeof window === 'undefined';
var getLang = function getLang(locale) {
  var _locale$split;

  return (locale == null ? void 0 : (_locale$split = locale.split('-')) == null ? void 0 : _locale$split[0]) || defaultLocaleCtx.lang;
};
function generateI18BasicConfig(_ref) {
  var i18nConfig = _ref.i18nConfig,
      locale = _ref.locale,
      disableSuspense = _ref.disableSuspense;
  var newi18nConfig = i18nConfig;
  newi18nConfig.lng = locale;

  if (disableSuspense) {
    newi18nConfig.react = {
      useSuspense: false
    };
  }

  return newi18nConfig;
}
function transformInitialDictionary(initialDictionary) {
  if (!initialDictionary) {
    return {};
  }

  return Object.keys(initialDictionary).reduce(function (total, curr) {
    var _curr, _extends2;

    return _extends({}, total, (_extends2 = {}, _extends2[curr] = (_curr = {}, _curr[DEFAULT_NAMESPACE] = initialDictionary[curr], _curr), _extends2));
  }, {});
}
function prependResources(_ref2) {
  var i18nConfig = _ref2.i18nConfig,
      resources = _ref2.resources;
  return _extends({}, i18nConfig, {
    resources: resources
  });
}
function initI18nCSROnly(_ref3) {
  var i18nInstance = _ref3.i18nInstance,
      i18nConfig = _ref3.i18nConfig,
      initialDictionary = _ref3.initialDictionary;

  var nextConfig = _extends({}, i18nConfig);

  if (i18nInstance.isInitialized) {
    var _process, _process$env;

    if (((_process = process) == null ? void 0 : (_process$env = _process.env) == null ? void 0 : _process$env.NODE_ENV) !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[nova.intl.csr] i18nInstance already initialized');
    } // eslint-disable-next-line no-void


    return i18nInstance;
  }

  nextConfig = prependResources({
    i18nConfig: nextConfig,
    resources: transformInitialDictionary(initialDictionary)
  }); // eslint-disable-next-line no-void

  void i18nInstance.init(nextConfig);
  return i18nInstance;
}
var cases = ['many', 'one', 'few', 'few', 'few', 'many'];
var getPluralIndexRu = function getPluralIndexRu(number) {
  if (Number.isInteger(number)) {
    return number % 100 > 4 && number % 100 < 20 ? cases[0] : cases[number % 10 < 5 ? number % 10 : 5];
  }

  return cases[1];
};
var getPluralIndexEn = function getPluralIndexEn(number) {
  return number !== 1 ? 'many' : 'one';
}; // NOTE: не очень оптимально, можно переделать потом, но не критичноы

var interpolateKey = function interpolateKey(str, key, value) {
  var keyRegexp = new RegExp("{{ " + key + " }}", 'i');
  return str.replace(keyRegexp, String(value));
};

export { generateI18BasicConfig, getLang, getPluralIndexEn, getPluralIndexRu, initI18nCSROnly, interpolateKey, isServer, prependResources, transformInitialDictionary };
